import { render, staticRenderFns } from "./QrCodeDialog.vue?vue&type=template&id=79ce8268&scoped=true&"
import script from "./QrCodeDialog.vue?vue&type=script&lang=js&"
export * from "./QrCodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeDialog.vue?vue&type=style&index=0&id=79ce8268&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ce8268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon})
